import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import config from "../configuration/config";
import { DropDownInput } from "../components/_input/_dropdown";
import { InputField } from "../components/_input/_input";
import crypto from "crypto-js";
import Joi from "joi";
import { formValidate, GetMessages } from "../utils/validation";
import { toast } from "react-toastify";
import { TabPanel, Tabs } from "react-tabs";
import PhoneDropDown from "../components/_input/_phoneDropDown";
import { FileInput } from "../components/_input/_fileInput";
import { getData, saveData, User_Data_Key } from "../utils/localStorageManager";
import { includes } from "lodash";
import DeleteAccountForm from "./components/DeleteAccountForm";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
SwiperCore.use([Navigation, Pagination]);


var USERFileds = " GUID,Web_UserID,GenderID,FirstNameAr,MiddleNameAr,LastNameAr,FirstNameEn,MiddleNameEn,LastNameEn,Email,Address,Phone,IdentityNumber,CustID,CityID,CR,CustGroupID,IsDeleted ";
export default function Profile() {
  const defaultProfileImage = "/assets/images/profile.jpg";
  // db.createDbRequest("UserDB", 1);
  const fileInputRef = useRef();
  const { t: trans, i18n } = useTranslation(["common", "form", "model", "user", "info", "hints", "error2", "inputs", "new", "extra"]);
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [acceptPasswordStatus, setAcceptPasswordStatus] = useState(false);
  const [genderList, setGenderList] = useState([{}]);
  const [selectedGender, setSelectedGender] = useState(null);
  const [imageProfile, setImageProfile] = useState(defaultProfileImage);
  const [accountTypes, setAccountTypes] = useState([]);
  const [settings, setSettings] = useState({
    countries: [],
    cities: [],
    genders: [],
  });

  const [showTintingAgreements] = useState({
    en: "Notice: Canceling your account will deactivate it and you will not be able to log in.\nYou can reactivate your account anytime by contacting customer support.",
    ar: "تنبيه: سيؤدي إلغاء الحساب إلى تعطيله ولن تتمكن من تسجيل الدخول.\nيمكنك إعادة تفعيل حسابك في أي وقت من خلال التواصل مع خدمة العملاء.",
  });
  const [filteredCities, setFilteredCities] = useState([]);
  const [defaultGeoLocation, setDefaultGeoLocation] = useState({ country: null, city: null });
  const [personalDataRequest, setPersonalDataRequest] = useState({
    arFirstName: "",
    arMiddleName: "",
    arLastName: "",
    enFirstName: "",
    enMiddleName: "",
    enLastName: "",
    genderID: "",
    address: "",
    cityID: "",
    countryID: "",
    logo: defaultProfileImage,
  });
  const [error, setError] = useState({});
  //------------------------------------------------------------------------
  const schemaPassword = Joi.object({
    newPassword: Joi.string().min(8).max(20).required().messages(GetMessages()),
    confirmPassword: Joi.string().valid(Joi.ref("newPassword")).required().messages(GetMessages()),
  });

  const [changePhoneNumber, setChangePhoneNumber] = useState(false);
  const [changeEmail, setChangeEmail] = useState(false);
  const [requestChangePassword, setRequestChangePassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [userHasNoPassword, setUserHasNoPassword] = useState(false);
  const [passwordError, setPasswordError] = useState({});
  //--------------------------------------------------------------------
  const [personalPhoneNumber, setPersonalPhoneNumber] = useState({
    phoneNumber: "",
  });
  const schemaPhoneNumber = Joi.object({
    phoneNumber: Joi.string().min(12).required().messages(GetMessages()),
  });
  const [phoneError, setPhoneError] = useState({});
  //------------------------------------------------------------------------

  const [identityTypeCurrent, setIdentityTypeCurrent] = useState(1);
  const [freazeType, setFrazeType] = useState(false);
  const [defaultIdentityType, setDefaultIdentityType] = useState(null);
  const [personalContactDataRequest, setPersonalContactDataRequest] = useState({
    email: "",
    phoneNumber: "",
    identityNo: "",
    identityImage: null,
  });

  const [personalDocumentDataRequest, setPersonalDocumentDataRequest] = useState({
    custGroupID: "",
    identityNo: "",
    identityImage: null,
    cn: "",
    cnImage: null,
  });

  const schemaDocument = Joi.object({
    identityNo: Joi.string().length(10).required().messages(GetMessages()),
    cn: Joi.string().length(10).required().messages(GetMessages()),
    custGroupID: Joi.string().required().messages(GetMessages()),
  });

  const [errorDocument, setErrorDocument] = useState(null);

  //-----------------------------------------------------------------
  const [personalEmailDataRequest, setPersonalEmailDataRequest] = useState({
    email: "",
  });

  const schemaEmail = Joi.object({
    email: Joi.string()
      .email({ minDomainSegments: 2, tlds: { allow: false } })
      .required()
      .messages(GetMessages()),
  });

  const [emailError, setEmailError] = useState({});
  //----------------------------------------------------------------

  const [personalIdentityDataRequest, setPersonalIdentityDataRequest] = useState({
    identity: "",
    identityImage: null,
  });
  const schemaIdentity = Joi.object({
    identity: Joi.string().length(10).required().messages(GetMessages()),
  });
  const [identityError, setIdentityError] = useState({});
  const [showIdentityImage, setShowIdentityImage] = useState(false);
  //-----------------------------------------------------------------
  const schemaSection1 = Joi.object({
    arFirstName: Joi.string().max(50).required().messages(GetMessages()),
    arMiddleName: Joi.string().max(50).required().messages(GetMessages()),
    arLastName: Joi.string().max(50).required().messages(GetMessages()),
    enFirstName: Joi.string().max(50).required().messages(GetMessages()),
    enMiddleName: Joi.string().max(50).required().messages(GetMessages()),
    enLastName: Joi.string().max(50).required().messages(GetMessages()),
    countryID: Joi.required().messages(GetMessages()),
    cityID: Joi.required().messages(GetMessages()),
  });

  useEffect(async () => {
    try {
      if ("caches" in window) {
        let url = "user/getSettings";

        // Opening that particular cache
        const cacheStorage = await caches.open("HJWeb");
        // Fetching that particular cache data
        const cachedResponse = await cacheStorage.match(url);
        let settingsResponse = await cachedResponse?.json();
        if (settingsResponse.status === 200) {
          setSettings(settingsResponse.data);
        }

        var mm = settingsResponse?.data?.genders.map((e) => {
          return { value: String(e.id), text: e.description };
        });
        setGenderList(mm);

        intialUserData(settingsResponse?.data);
      }
    } catch (error) { }

    try {
      const settingsResponse = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/user/getSettings",
        method: "get",
      });

      if (settingsResponse.status === 200) {
        setSettings(settingsResponse.data);
      }

      var mm = settingsResponse?.data?.genders.map((e) => {
        return { value: String(e.id), text: e.description };
      });
      setGenderList(mm);

      intialUserData(settingsResponse?.data);

      const data = new Response(JSON.stringify(settingsResponse));

      if ("caches" in window) {
        // Opening given cache and putting our data into it
        caches.open("HJWeb").then((cache) => {
          cache.put("user/getSettings", data);
        });
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const intialIdentityTypes = async () => {
    let responseData = [];
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteGetCustomerAccountTypes`, {});
      if (response.status == 200) {
        responseData = response.data;
        setAccountTypes(responseData);
        fetchWebUserData();
      }
    } catch (err) {
      console.log(err);
      fetchWebUserData();
    }
    return responseData;
  };

  const handlePicker = () => {
    fileInputRef.current.click();
  };

  const intialUserData = async (data) => {
    try {
      const genderModel = trans("model:description");
      const userData = JSON.parse(getData(User_Data_Key, true));

      console.log(userData);
      if (userData) {
        if (userData.logo) {
          setImageProfile(URL.createObjectURL(b64toBlob(userData?.logo)));
        } else {
          setImageProfile(defaultProfileImage);
        }
        if (userData.genderID) {
          const userGender = data?.genders?.find((item) => String(item.id) == String(userData?.genderID));
          if (userGender) {
            setSelectedGender({ text: userGender.description, value: String(userGender.id) });
          }
        }

        const { custGroupID, identity, tradeNo, countryID, cityID } = { ...userData };

        const cResult =
          data?.countries?.find((item) => {
            return item.id == countryID;
          }) ?? null;

        setFilteredCities(
          data?.cities?.filter((item) => {
            return item.code == countryID;
          }),
        );
        setTimeout(() => {
          setPersonalDataRequest(userData);

          const ccResult =
            data?.cities?.find((item) => {
              return item.id == cityID;
            }) ?? null;

          const _userGeo = { country: null, city: null };

          if (cResult) {
            _userGeo.country = { text: cResult?.description, value: cResult?.id };
          }
          if (ccResult) {
            _userGeo.city = { text: ccResult?.description, value: ccResult?.id };
          }

          setDefaultGeoLocation(_userGeo);
        }, 1000);

        const results = await intialIdentityTypes();
        if (results?.length > 0) {
          const value = results.find((item) => {
            return item.ID === custGroupID;
          });
          if (value) {
            const finalValue = value.NeedIdentity == true ? 1 : value.NeedIdentity == false ? 2 : null;
            // setIdentityType(finalValue); // Removed
            setDefaultIdentityType({ text: value[`${trans("model:description")}`], value: value.ID });
            if (finalValue == 1 && identity !== "") {
              // setFrazeType(true);
            } else if (finalValue == 2 && tradeNo !== "") {
              // setFrazeType(true);
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    console.log(">>>>>>>>>>>>>>>>>GetUserImage>>>>>>>>>>>>>>>>>>:");
    try {
      const userKey = getData("secretKey");
      console.log(">>>>>>>>>>>>>>>>>GetUserImage>>>>>>>>userKey>>>>>>>>>>:", userKey);
      const settingsResponse = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/user/GetUserImage",
        method: "get",
        params: {
          ID: userKey,
        },
      });

      if (settingsResponse?.status === 200) {
        const imgeUser = settingsResponse?.data?.userImage?.Logo;

        if (imgeUser) {
          setImageProfile(URL.createObjectURL(b64toBlob(imgeUser)));
        } else {
          setImageProfile(defaultProfileImage);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  const intialUserContactData = (userData) => {
    // console.log(">>>>>>intialUserContactData>>>>>>>>>>>:", userData);

    if (!userData) {
      userData = JSON.parse(getData(User_Data_Key, true));
      // console.log(">>>>>>getData>>>>>>>>>>>:", userData);
    }

    if (userData) {
      const { email, phone, identity, identityImage, tradeNo, tradeNoImage, custGroupID } = userData;

      setPersonalContactDataRequest({
        phoneNumber: phone,
        identityNo: identity,
        email: email,
        identityImage: identityImage,
      });
      setPersonalIdentityDataRequest({
        identity: identity,
        identityImage: identityImage,
      });
      setPersonalDocumentDataRequest({
        identityNo: identity ?? "",
        identityImage,
        cn: tradeNo ?? "",
        cnImage: tradeNoImage,
        custGroupID: custGroupID ?? "",
      });
    }
  };
  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays);
    return blob;
  };

  const fetchCustData = async (CustID) => {
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/DetailscustTable`, {
        ObjectSettings: {
          MetaData: false,
        },
        Option: "Column",
        Fields: "DescriptionAr,DescriptionEn",
        Filters: `where CustID = '${CustID}' `,
      });
      if (response.status == 200) {
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchWebUserData = async () => {
    try {
      const userKey = getData("secretKey");
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/Detailsweb_users`, {
        ObjectSettings: {
          MetaData: false,
        },
        Option: "Column",
        Fields: `${USERFileds}`,
        Filters: `where GUID = '${userKey}'`,
      });
      if (response.status == 200) {
        var queryResult = response.data.ApiObjectData[0];
        const userdata = {
          id: queryResult.GUID + "_" + queryResult.Web_UserID,
          genderId: queryResult.GenderID,
          arFirstName: queryResult.FirstNameAr,
          arMiddleName: queryResult.MiddleNameAr,
          arLastName: queryResult.LastNameAr,
          enFirstName: queryResult.FirstNameEn,
          enMiddleName: queryResult.MiddleNameEn,
          enLastName: queryResult.LastNameEn,
          email: queryResult.Email,
          address: queryResult.Address,
          phone: queryResult.Phone,
          identity: queryResult.IdentityNumber,
          custId: queryResult.CustID,
          countryId: queryResult.CountryID,
          cityId: queryResult.CityID,
          logo: queryResult.Logo,
          identityImage: queryResult.IdentityImage,
          tradeNo: queryResult.CR,
          tradeNoImage: queryResult.CRImage,
          custGroupId: queryResult.CustGroupID,
        };

        intialUserContactData(userdata);
      }
    } catch (err) {
      console.log(err);
      intialUserContactData();
    }
  };
  const handleChangeImage = async (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      const fileURL = URL.createObjectURL(files[0]);
      setImageProfile(fileURL);
      const fileBase64 = await toBase64(files[0]);
      const finalFile = fileBase64.substr(fileBase64.indexOf(",") + 1, fileBase64.length);
      const val = { ...personalDataRequest };
      val.logo = finalFile;
      setPersonalDataRequest(val);
    }
  };
  const handleChangeIdentityImage = async (event) => {
    const files = event.target.files;
    const val = { ...personalDocumentDataRequest };
    if (files.length > 0) {
      const fileBase64 = await toBase64(files[0]);
      const finalFile = fileBase64.substr(fileBase64.indexOf(",") + 1, fileBase64.length);
      val.identityImage = finalFile;
    } else {
      val.identityImage = val.identityImage || null;
    }
    setPersonalDocumentDataRequest(val);
  };
  const handleChangeCRImage = async (event) => {
    const files = event.target.files;
    const val = { ...personalDocumentDataRequest };
    if (files.length > 0) {
      const fileBase64 = await toBase64(files[0]);
      const finalFile = fileBase64.substr(fileBase64.indexOf(",") + 1, fileBase64.length);
      val.cnImage = finalFile;
    } else {
      val.cnImage = val.cnImage || null;
    }
    setPersonalDocumentDataRequest(val);
  };
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const isPasswordMatched = async () => {
    let isMatched = false;
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/DetailsWeb_Users`, {
        ObjectSettings: {
          MetaData: false,
        },
        Option: "Column",
        Fields: "DescriptionAr",
        Filters: `where GUID = '${getData("secretKey")}'  and password = '${crypto.MD5(requestChangePassword?.oldPassword).toString()}'`,
      });
      if (response.status == 200) {
        isMatched = response.data.ApiObjectData?.length != 0;
      }
      return isMatched;
    } catch (err) {
      console.log(err);
    }
  };
  // to change the current user password
  const handleChangePassword = async () => {
    const result = formValidate(schemaPassword, requestChangePassword) ?? {};
    setPasswordError(result);
    console.log("userHasNoPassword:>>>>>>>>>>>>>>>>", userHasNoPassword);
    if (Object.keys(result).length == 0) {
      setIsLoading2(true);
      if (userHasNoPassword) {
        axios
          .post(`${config.controllURL}${lang}/api/Pages/SiteCheckUserHasNoPassword`, {
            guid: `${getData("secretKey")}`,
          })
          .then((response) => {
            console.log("SiteCheckUserHasNoPassword:>>>>>>>>>>>>>>>>", response?.data);
            console.log("acceptPasswordStatus:>>>>>>>>>>>>>>>>", acceptPasswordStatus);
            if (response?.data) {
              if (acceptPasswordStatus) {
                axios
                  .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
                    Values: {
                      Password: crypto.MD5(requestChangePassword.newPassword).toString(),
                    },
                    Filters: `where GUID = '${getData("secretKey")}'`,
                  })
                  .then((response) => {
                    if (response.status === 200) {
                      toast.success(trans("common:update-successful"));
                      setRequestChangePassword({ oldPassword: "", newPassword: "", confirmPassword: "" });
                    } else {
                      toast.error("error:unknown_failure");
                    }
                  });
              }
            } else {
              toast.error(trans("error2:user_has_pre_password"));
            }
          });
      } else {
        if (await isPasswordMatched()) {
          if (acceptPasswordStatus) {
            axios
              .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
                Values: {
                  Password: crypto.MD5(requestChangePassword.newPassword).toString(),
                },
                Filters: `where GUID = '${getData("secretKey")}'`,
              })
              .then((response) => {
                if (response.status === 200) {
                  toast.success(trans("common:update-successful"));
                  setRequestChangePassword({ oldPassword: "", newPassword: "", confirmPassword: "" });
                } else {
                  toast.error("error:unknown_failure");
                }
              });
          }
        } else {
          toast.error(trans("common:wrong-password"));
        }
      }
    }
    setIsLoading2(false);
  };
  // to change personal data
  const handleChangePersonalData = () => {
    const result = formValidate(schemaSection1, personalDataRequest) ?? {};
    setError(result);
    if (Object.keys(result).length == 0) {
      if (readOnly) {
        toast.error(trans("common:enable-read-only"));
        return;
      }
      setIsLoading(true);
      const userKey = getData("secretKey");
      axios
        .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
          Values: {
            firstNameAr: personalDataRequest?.arFirstName.trim(),
            middleNameAr: personalDataRequest?.arMiddleName.trim(),
            lastNameAr: personalDataRequest?.arLastName.trim(),
            firstNameEn: personalDataRequest?.enFirstName.trim(),
            middleNameEn: personalDataRequest?.enMiddleName.trim(),
            lastNameEn: personalDataRequest?.enLastName.trim(),
            GenderID: personalDataRequest?.genderID != "" && personalDataRequest?.genderID != undefined ? Number(personalDataRequest?.genderID) : Number(settings?.genders[0].id),
            Address: personalDataRequest.address ?? "",
            Logo: personalDataRequest?.logo,
            countryID: personalDataRequest?.countryID ?? null,
            cityID: personalDataRequest?.cityID ?? null,
          },
          Filters: `where GUID = '${userKey}'`,
        })
        .then((response) => {
          if (response.status == 200) {
            toast.success(trans("common:update-successful"));
            setIsLoading(false);
            setReadOnly(true);
            // setEditableStatus(0); // Removed as editableStatus is no longer a state variable
            saveData(User_Data_Key, personalDataRequest, true);
            window.location = "/user/profile";
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };
  // to change user phone number
  const handleChangePhoneNumber = async () => {
    const result = formValidate(schemaPhoneNumber, personalPhoneNumber) ?? {};
    setPhoneError(result);
    if (Object.keys(result).length == 0) {
      try {
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteNewPhoneNumberExisting`, {
          phoneNumber: `${personalPhoneNumber.phoneNumber}`,
        });
        if (response.status == 200) {
          if (response.data) {
            toast.error(trans("error2:phone_number_existing"));
          } else {
            // the following code is to change the phone number
            axios
              .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
                Values: {
                  Phone: `${personalPhoneNumber.phoneNumber}`,
                },
                Filters: `where GUID = '${getData("secretKey")}'`,
              })
              .then((responseData) => {
                if (responseData.status == 200) {
                  toast.success(trans("info:success_update_phone"));
                  const currentValue = JSON.parse(getData(User_Data_Key, true));
                  currentValue.phone = personalPhoneNumber.phoneNumber;
                  saveData(User_Data_Key, currentValue, true);
                  window.location = "/user/profile";
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  // to chnage user email
  const handleChangeEmail = async () => {
    const result = formValidate(schemaEmail, personalEmailDataRequest) ?? {};
    setEmailError(result);
    if (Object.keys(result).length == 0) {
      try {
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteNewEmailExisting`, {
          email: `${personalEmailDataRequest.email.trim()}`,
        });
        if (response.status == 200) {
          if (response.data) {
            toast.error(trans("error2:email_existing"));
          } else {
            // the following code is to change the phone number
            axios
              .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
                Values: {
                  email: `${personalEmailDataRequest.email.trim()}`,
                },
                Filters: `where GUID = '${getData("secretKey")}'`,
              })
              .then((responseData) => {
                toast.success(trans("info:success_update_email"));
                const currentValue = JSON.parse(getData(User_Data_Key, true));
                currentValue.email = personalEmailDataRequest.email;
                saveData(User_Data_Key, currentValue, true);
                window.location = "/user/profile";
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  // to change the identity info for the user
  const handleChangeIdentity = async () => {
    const result = formValidate(schemaIdentity, personalIdentityDataRequest) ?? {};
    setIdentityError(result);
    if (Object.keys(result).length == 0) {
      try {
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteNewIdentityExisting`, {
          identity: `${personalIdentityDataRequest.identity}`,
          guid: `${getData("secretKey")}`,
        });
        if (response.status == 200) {
          if (response.data) {
            toast.error(trans("error2:identity_existing"));
          } else {
            axios
              .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
                Values: {
                  IdentityNumber: `${personalIdentityDataRequest.identity}`,
                  IdentityImage: personalIdentityDataRequest.identityImage,
                },
                Filters: `where GUID = '${getData("secretKey")}'`,
              })
              .then((responseData) => {
                toast.success(trans("common:update-successful"));
                const currentValue = JSON.parse(getData(User_Data_Key, true));
                currentValue.identity = personalIdentityDataRequest.identity;
                currentValue.identityImage = personalIdentityDataRequest.identityImage;
                saveData(User_Data_Key, currentValue, true);
                window.location = "/user/profile";
              })
              .catch((error) => {
                console.log(error);
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  // to handle the identity type [cn-identity]
  const handleChangeIdentityType = async () => {
    const val = { ...personalDocumentDataRequest };
    const result = formValidate(schemaDocument, val);
    setIsLoading(true);
    if (freazeType) {
      if (identityTypeCurrent == 1) {
        axios
          .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
            Values: {
              CRImage: personalDocumentDataRequest.cnImage,
            },
            Filters: `where GUID = '${getData("secretKey")}'`,
          })
          .then((response) => {
            setIsLoading(false);
            toast.success(trans("common:update-successful"));
            const currentValue = JSON.parse(getData(User_Data_Key, true));
            currentValue.identityImage = personalDocumentDataRequest.identityImage;
            saveData(User_Data_Key, currentValue, true);
            window.location = "/user/profile";
          })
          .catch((err) => {
            console.log(err);
            setIsLoading(false);
          });
      } else if (identityTypeCurrent == 2) {
        axios
          .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, {
            Values: {
              CRImage: personalDocumentDataRequest.cnImage,
            },
            Filters: `where GUID = '${getData("secretKey")}'`,
          })
          .then((response) => {
            setIsLoading(false);
            toast.success(trans("common:update-successful"));
            const currentValue = JSON.parse(getData(User_Data_Key, true));
            currentValue.tradeNoImage = personalDocumentDataRequest.cnImage;
            saveData(User_Data_Key, currentValue, true);
            window.location = "/user/profile";
          })
          .catch((err) => {
            console.log(err);
            setIsLoading(false);
          });
      }
    } else {
      let values = {};
      let options = [];
      let jsonRequest;
      let messageError;
      // identity card
      if (identityTypeCurrent == 1) {
        messageError = "error2:identity_existing";
        options = ["identityNo", "custGroupID"];
        values = {
          Values: {
            CustGroupID: personalDocumentDataRequest.custGroupID,
            IdentityNumber: personalDocumentDataRequest.identityNo,
            IdentityImage: personalDocumentDataRequest.identityImage,
          },
          Filters: `where GUID = '${getData("secretKey")}'`,
        };
        // ----------------------------------------------------
        jsonRequest = {
          Name: "SiteNewIdentityExisting",
          Values: {
            identity: `${personalDocumentDataRequest.identityNo}`,
            guid: `${getData("secretKey")}`,
          },
        };
      } else if (identityTypeCurrent == 2) {
        messageError = "error2:cr_existing";
        options = ["cn", "custGroupID"];
        values = {
          Values: {
            CustGroupID: personalDocumentDataRequest.custGroupID,
            TradeNo: personalDocumentDataRequest.cn,
            TradeNoImage: personalDocumentDataRequest.cnImage,
          },
          Filters: `where GUID = '${getData("secretKey")}'`,
        };
        jsonRequest = {
          Name: "SiteNewCRExisting",
          Values: {
            identity: `${personalDocumentDataRequest.cn}`,
            guid: `${getData("secretKey")}`,
          },
        };
      }
      const newErrors = removeUnspecific2Error(result, options);
      setErrorDocument(newErrors);
      const _isFound = await isFound(jsonRequest);
      if (!_isFound) {
        if (Object.keys(newErrors).length === 0) {
          axios
            .put(`${config.controllURL}${lang}/api/Pages/UpdateWeb_users`, values)
            .then((response) => {
              setIsLoading(false);
              toast.success(trans("common:update-successful"));
              const currentValue = JSON.parse(getData(User_Data_Key, true));
              currentValue.tradeNoImage = personalDocumentDataRequest.cnImage;
              currentValue.tradeNo = personalDocumentDataRequest.cn;
              currentValue.identity = personalDocumentDataRequest.identityNo;
              currentValue.identityImage = personalDocumentDataRequest.identityImage;
              currentValue.custGroupID = personalDocumentDataRequest.custGroupID;
              saveData(User_Data_Key, currentValue, true);
              window.location = "/user/profile";
            })
            .catch((err) => {
              console.log(err);
              setIsLoading(false);
            });
        }
      } else {
        toast.error(trans(messageError));
      }
    }
  };
  // to remove the unneeded props
  const removeUnspecific2Error = (errorList, values = []) => {
    let errorResult = {};
    if (values?.length > 0) {
      const lowerValues = values.map((item) => {
        return item.toLowerCase();
      });
      Object.assign(errorResult, errorList);
      if (errorList) {
        for (let index = 0; index < Object.keys(errorList).length; index++) {
          const key = Object.keys(errorList)[index];
          if (includes(lowerValues, key.toLowerCase())) {
            continue;
          } else {
            delete errorResult[key];
          }
        }
      }
    }
    return errorResult;
  };

  const getCorrectIdentitySection = () => {
    let result = <></>;
    if (identityTypeCurrent == 1) {
      result = (
        <>
          <div className="v7-input-group lg:col-span-1">
            <label>{trans("form:identity-no")}</label>
            <input
              className="v7-input"
              disabled={freazeType}
              value={personalDocumentDataRequest.identityNo}
              placeholder={trans("hints:identity_hint")}
              maxLength={10}
              onChange={(e) => {
                const val = { ...personalDocumentDataRequest };
                val.identityNo = e.target.value;
                setPersonalDocumentDataRequest(val);
              }}
            />
            {errorDocument?.identityNo && <span className="text-red-500 text-12 mt-1">{errorDocument?.identityNo}</span>}
          </div>
          <div className="v7-input-group lg:col-span-1">
            <label>{trans("info:identity_image")}</label>
            <FileInput
              mimeType="image/*"
              onPicker={async (file) => {
                await handleChangeIdentityImage(file);
              }}
            />
            {personalDocumentDataRequest?.identityImage && (
              <div className="mt-2">
                <button
                  className="text-primary text-14 font-bold hover:underline"
                  onClick={() => setShowIdentityImage(!showIdentityImage)}>
                  {trans("user:show")}
                </button>
                {showIdentityImage && <img src={"data:image/png;base64," + personalDocumentDataRequest?.identityImage} className="mt-3 rounded-lg max-w-full h-auto shadow-sm" />}
              </div>
            )}
          </div>
        </>
      );
    } else if (identityTypeCurrent == 2) {
      result = (
        <>
          <div className="v7-input-group lg:col-span-1">
            <label>{trans("user:cn")}</label>
            <input
              className="v7-input"
              disabled={freazeType}
              value={personalDocumentDataRequest.cn}
              placeholder={trans("hints:cr_hint")}
              maxLength={10}
              onChange={(e) => {
                const val = { ...personalDocumentDataRequest };
                val.cn = e.target.value;
                setPersonalDocumentDataRequest(val);
              }}
            />
            {errorDocument?.cn && <span className="text-red-500 text-12 mt-1">{errorDocument?.cn}</span>}
          </div>
          <div className="v7-input-group lg:col-span-1">
            <label>{trans("user:cn_image")}</label>
            <FileInput
              mimeType="image/*"
              onPicker={async (file) => {
                await handleChangeCRImage(file);
              }}
            />
            {personalDocumentDataRequest?.cnImage && (
              <div className="mt-2">
                <button
                  className="text-primary text-14 font-bold hover:underline"
                  onClick={() => setShowIdentityImage(!showIdentityImage)}>
                  {trans("user:show")}
                </button>
                {showIdentityImage && <img src={"data:image/png;base64," + personalDocumentDataRequest?.cnImage} className="mt-3 rounded-lg max-w-full h-auto shadow-sm" />}
              </div>
            )}
          </div>
        </>
      );
    }
    return result;
  };

  const isFound = async (jsonRequest) => {
    let isExisting = false;
    try {
      const endpointName = jsonRequest.Name || jsonRequest.name;
      const body = jsonRequest.Values || jsonRequest.values || {};
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/${endpointName}`, body);
      if (response.status === 200) {
        isExisting = response.data;
      }
    } catch (err) {
      console.log(err);
    }
    return isExisting;
  };

  const names = lang === "ar"
    ? `${personalDataRequest.arFirstName} ${personalDataRequest.arLastName}`
    : `${personalDataRequest.enFirstName} ${personalDataRequest.enLastName}`;

  const profileTabs = [
    { id: 0, label: trans("user:profile") },
    { id: 1, label: trans("user:contact_info") },
    { id: 2, label: trans("user:secret_info") },
    { id: 3, label: trans("user:delete_account"), isDanger: true }
  ];

  return (
    <div className={`user-page-container ${languageDir}`}>
      <Tabs
        className="profile-tabs-v7"
        selectedIndex={activeTabIndex}
        onSelect={(index) => setActiveTabIndex(index)}
      >
        <div className="model-selector-tabs mb-8" style={{ maxWidth: '100%', background: 'transparent', padding: 0 }}>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={12}
            centerInsufficientSlides={false}
            className="tabs-swiper"
            style={{ padding: '8px 0' }}
          >
            {profileTabs.map((tab) => (
              <SwiperSlide key={tab.id} style={{ width: 'auto' }}>
                <div
                  className={`model-chip ${activeTabIndex === tab.id ? 'selected' : ''} ${tab.isDanger ? 'chip-danger' : ''}`}
                  onClick={() => setActiveTabIndex(tab.id)}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <div className="chip-check">
                    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="4">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span className="chip-label">{tab.label}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Profile Details Tab */}
        <TabPanel>
          <div className="profile-card-v7">
            <div className="flex flex-col md:flex-row items-center gap-8 mb-10">
              <div className="relative group">
                <div
                  className="w-32 h-32 rounded-full border-4 border-green-500 p-1 bg-white cursor-pointer overflow-hidden transform group-hover:scale-105 transition-transform duration-300"
                  onClick={handlePicker}
                >
                  <img src={imageProfile} alt="Profile" className="w-full h-full rounded-full object-cover" />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full">
                    <img src="/assets/icons/upload.svg" className="w-8 h-8 filter brightness-0 invert" alt="Upload" />
                  </div>
                </div>
                <input type="file" ref={fileInputRef} accept="image/*" className="hidden" onChange={handleChangeImage} />
              </div>

              <div className="text-center md:text-left flex-1">
                <h2 className="text-28 font-black mb-1">{names}</h2>
                <div className="flex flex-wrap justify-center md:justify-start gap-4">
                  <span className="flex items-center gap-2 text-14 font-bold text-gray-500 bg-gray-100 dark:bg-zinc-800 px-3 py-1.5 rounded-full">
                    <img src="/assets/user_profile/icons/user.svg" className="w-4 h-4 opacity-50" />
                    {selectedGender?.text || trans("form:gender")}
                  </span>
                  <span className="flex items-center gap-2 text-14 font-bold text-gray-500 bg-gray-100 dark:bg-zinc-800 px-3 py-1.5 rounded-full">
                    <img src="/assets/user_profile/icons/notification.svg" className="w-4 h-4 opacity-50" />
                    {personalDataRequest?.email}
                  </span>
                </div>
              </div>

              <button
                className={readOnly ? "v7-btn-primary" : "v7-btn-warning"}
                onClick={() => {
                  if (!readOnly) {
                    setReadOnly(true);
                  } else {
                    setReadOnly(false);
                  }
                }}
              >
                {readOnly ? trans("user:edit") : trans("common:cancel")}
              </button>
            </div>

            <h3 className="profile-section-title">{trans("user:private_info")}</h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {/* Arabic Name Inputs */}
              <div className="v7-input-group">
                <label>{trans("form:first-name")} ({trans("user:ar")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.arFirstName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, arFirstName: e.target.value })}
                />
                {error?.arFirstName && <span className="text-red-500 text-12">{error.arFirstName}</span>}
              </div>
              <div className="v7-input-group">
                <label>{trans("info:middle-name")} ({trans("user:ar")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.arMiddleName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, arMiddleName: e.target.value })}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("info:surname")} ({trans("user:ar")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.arLastName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, arLastName: e.target.value })}
                />
              </div>

              {/* English Name Inputs */}
              <div className="v7-input-group">
                <label>{trans("form:first-name")} ({trans("user:en")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.enFirstName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, enFirstName: e.target.value })}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("info:middle-name")} ({trans("user:en")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.enMiddleName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, enMiddleName: e.target.value })}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("info:surname")} ({trans("user:en")})</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.enLastName}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, enLastName: e.target.value })}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10">
              <div className="v7-input-group">
                <label>{trans("form:gender")}</label>
                <DropDownInput
                  defaultOption={selectedGender ?? genderList[0]}
                  onSelect={(option) => setPersonalDataRequest({ ...personalDataRequest, genderID: String(option) })}
                  selectedValue={personalDataRequest.genderID}
                  options={genderList}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("extra:country")}</label>
                <DropDownInput
                  defaultOption={defaultGeoLocation?.country?.value}
                  onSelect={(option) => setPersonalDataRequest({ ...personalDataRequest, countryID: String(option) })}
                  selectedValue={personalDataRequest.countryID}
                  options={settings?.countries?.map(item => ({ text: item.description, value: item.id }))}
                  onfilter={(value) => {
                    setFilteredCities(settings?.cities?.filter(item => item.code == value?.value));
                  }}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("extra:city")}</label>
                <DropDownInput
                  defaultOption={defaultGeoLocation?.city?.value}
                  selectedValue={personalDataRequest.cityID}
                  onSelect={(option) => setPersonalDataRequest({ ...personalDataRequest, cityID: String(option) })}
                  options={filteredCities?.map(item => ({ text: item.description, value: String(item.id) }))}
                />
              </div>
              <div className="v7-input-group">
                <label>{trans("extra:street")}</label>
                <input
                  className="v7-input"
                  disabled={readOnly}
                  value={personalDataRequest.address}
                  onChange={(e) => setPersonalDataRequest({ ...personalDataRequest, address: e.target.value })}
                />
              </div>
            </div>

            {!readOnly && (
              <div className="flex justify-end">
                <button className="v7-btn-primary" onClick={handleChangePersonalData} disabled={isLoading}>
                  {isLoading ? trans("common:loading") : trans("info:save_changes")}
                </button>
              </div>
            )}
          </div>

          <div className="profile-card-v7">
            <h3 className="profile-section-title">{trans("user:identity_data")}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-end">
              <div className="v7-input-group">
                <label>{trans("info:account_type")}</label>
                <DropDownInput
                  force={true}
                  defaultOption={defaultIdentityType}
                  disabled={freazeType}
                  options={accountTypes.map(item => ({
                    text: lang === "ar" ? item.DescriptionAr : item.DescriptionEn,
                    value: item.ID,
                    isClient: item.NeedIdentity
                  }))}
                  selectedValue={personalDocumentDataRequest.custGroupID}
                  onfilter={(option) => {
                    if (option.value && option.value !== "0") {
                      setIdentityTypeCurrent(option.isClient ? 1 : 2);
                      setPersonalDocumentDataRequest({ ...personalDocumentDataRequest, custGroupID: option.value });
                    }
                  }}
                />
              </div>
              {getCorrectIdentitySection()}
            </div>
            <div className="flex justify-end mt-8">
              <button className="v7-btn-primary" onClick={handleChangeIdentityType} disabled={isLoading}>
                {isLoading ? trans("common:loading") : trans("form:save")}
              </button>
            </div>
          </div>
        </TabPanel>

        {/* Contact Info Tab */}
        <TabPanel>
          <div className="profile-card-v7">
            <h3 className="profile-section-title">{trans("user:contact_info")}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              {/* Phone Section */}
              <div className="flex flex-col gap-6">
                <div className="v7-input-group">
                  <label>{trans("user:current_phone")}</label>
                  <input className="v7-input opacity-60" value={personalContactDataRequest.phoneNumber} readOnly disabled />
                  <button
                    className="mt-3 text-14 font-bold text-green-600 hover:scale-105 transition-transform origin-left block"
                    onClick={() => setChangePhoneNumber(!changePhoneNumber)}
                  >
                    {trans("user:update_phone_note")}
                  </button>
                </div>

                {changePhoneNumber && (
                  <div className="p-6 rounded-2xl bg-gray-50 dark:bg-zinc-800 shadow-inner border border-gray-100 dark:border-zinc-700 animate-in fade-in slide-in-from-top-4 duration-300">
                    <PhoneDropDown
                      title={trans("user:new_phone_number")}
                      errorLabel={phoneError?.phoneNumber}
                      onChangeValue={(countryCode, phoneNumber) => setPersonalPhoneNumber({ phoneNumber: `+${countryCode}${phoneNumber}` })}
                    />
                    <button className="v7-btn-primary w-full mt-4" onClick={handleChangePhoneNumber} disabled={isLoading}>
                      {trans("form:save")}
                    </button>
                  </div>
                )}
              </div>

              {/* Email Section */}
              <div className="flex flex-col gap-6">
                <div className="v7-input-group">
                  <label>{trans("form:email")}</label>
                  <input className="v7-input opacity-60" value={personalContactDataRequest.email} readOnly disabled />
                  <button
                    className="mt-3 text-14 font-bold text-green-600 hover:scale-105 transition-transform origin-left block"
                    onClick={() => setChangeEmail(!changeEmail)}
                  >
                    {trans("user:update_email_note")}
                  </button>
                </div>

                {changeEmail && (
                  <div className="p-6 rounded-2xl bg-gray-50 dark:bg-zinc-800 shadow-inner border border-gray-100 dark:border-zinc-700 animate-in fade-in slide-in-from-top-4 duration-300">
                    <div className="v7-input-group">
                      <label>{trans("form:email")} ({trans("info:new")})</label>
                      <input
                        className="v7-input"
                        placeholder={trans("hints:email_hint")}
                        value={personalEmailDataRequest.email}
                        onChange={(e) => setPersonalEmailDataRequest({ ...personalEmailDataRequest, email: e.target.value })}
                      />
                      {emailError?.email && <span className="text-red-500 text-12">{emailError.email}</span>}
                    </div>
                    <button className="v7-btn-primary w-full mt-4" onClick={handleChangeEmail} disabled={isLoading}>
                      {trans("form:save")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </TabPanel>

        {/* Security / Secret Info Tab */}
        <TabPanel>
          <div className="profile-card-v7">
            <h3 className="profile-section-title">{trans("user:secret_info")}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div className="v7-input-group">
                <label>{trans("form:user-current-password")}</label>
                <input
                  type="password"
                  className="v7-input"
                  value={requestChangePassword?.oldPassword}
                  onChange={(e) => setRequestChangePassword({ ...requestChangePassword, oldPassword: e.target.value.trim() })}
                />
                {passwordError?.oldPassword && <span className="text-red-500 text-12">{passwordError.oldPassword}</span>}
                <div className="mt-4 flex items-center gap-3">
                  <input
                    type="checkbox"
                    id="no-pass"
                    className="w-5 h-5 accent-green-500"
                    onChange={(e) => setUserHasNoPassword(e.target.checked)}
                  />
                  <label htmlFor="no-pass" className="text-14 font-bold cursor-pointer m-0">{trans("info:user_has_password")}</label>
                </div>
              </div>

              <div className="flex flex-col gap-6">
                <div className="v7-input-group">
                  <label>{trans("form:user-new-password")}</label>
                  <InputField
                    value={requestChangePassword?.newPassword}
                    passwordStrength={true}
                    type="password"
                    onAcceptPassword={setAcceptPasswordStatus}
                    onChangeValue={(e) => setRequestChangePassword({ ...requestChangePassword, newPassword: e.target.value })}
                  />
                </div>
                <div className="v7-input-group">
                  <label>{trans("form:confirm-password")}</label>
                  <input
                    type="password"
                    className="v7-input"
                    value={requestChangePassword?.confirmPassword}
                    onChange={(e) => setRequestChangePassword({ ...requestChangePassword, confirmPassword: e.target.value })}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end">
              <button className="v7-btn-primary" onClick={handleChangePassword} disabled={isLoading2}>
                {isLoading2 ? trans("common:loading") : trans("info:save_changes")}
              </button>
            </div>
          </div>
        </TabPanel>

        {/* Delete Account Tab */}
        <TabPanel>
          <div className="profile-card-v7 border-red-500/10">
            <h3 className="profile-section-title text-red-600 before:bg-red-600">{trans("user:delete_account")}</h3>
            <div className="bg-red-50 dark:bg-red-900/10 p-6 rounded-2xl flex items-start gap-4 mb-10 border border-red-100 dark:border-red-900/30">
              <img src="/assets/icons/info.svg" className="w-6 h-6 mt-1 flex-shrink-0" alt="info" />
              <p className="font-bold text-gray-700 dark:text-red-200 leading-relaxed m-0" style={{ whiteSpace: "pre-line" }}>
                {showTintingAgreements[lang ?? "ar"]}
              </p>
            </div>
            <DeleteAccountForm user={personalDataRequest} trans={trans} />
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
}
